export const productKey = (value) => String(
  typeof value === "object"
    ? value?.id ?? value?.productid ?? value?.product_id ?? ""
    : value ?? ""
).trim();

export const productIdForPayload = (value) => {
  const key = productKey(value);
  const numeric = Number(key);
  return key && Number.isFinite(numeric) ? numeric : key;
};

export const mapOfflinePosCatalog = (categories, products, uncategorizedId) => {
  const categoryRecords = Array.isArray(categories) ? categories : [];
  const productRecords = Array.isArray(products) ? products : [];
  const categoryIds = new Set(categoryRecords.map((category) => String(
    category?.id ?? category?.productcategoryid ?? ""
  )));
  let hasUncategorized = false;
  const mappedProducts = productRecords.map((product) => {
    const categoryId = String(product?.productcategoryid ?? "");
    if (categoryId && categoryIds.has(categoryId)) return product;
    hasUncategorized = true;
    return {
      ...product,
      __offlineOriginalCategoryId: categoryId,
      productcategoryid: uncategorizedId,
    };
  });
  const mappedCategories = categoryRecords.map((category) => ({
    id: category.id ?? category.productcategoryid,
    name: category.productcategoryname || category.name || "",
  }));
  if (hasUncategorized) {
    mappedCategories.push({ id: uncategorizedId, name: "Uncategorized" });
  }
  return { categories: mappedCategories, products: mappedProducts };
};
